import './App.css';
import './Logo.tsx'
import SVGComponent from "./Logo.tsx";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {ThankYou} from "./ThankYou.tsx";

export function App() {
  const handleBookMeeting = () => {
    window.open('https://cal.com/kiamesdavies/pilotx', '_blank');
  };

  return (
      <Router>
          <Routes>
              <Route path="/" element={ <div className="teaser-container">
                  <div className="floating-elements">
                      <div className="float-card card-1">
                          <div className="mini-chart">
                              <div className="chart-bars">
                                  <div className="bar" style={{ height: '40%' }}></div>
                                  <div className="bar" style={{ height: '70%' }}></div>
                                  <div className="bar" style={{ height: '55%' }}></div>
                                  <div className="bar" style={{ height: '80%' }}></div>
                              </div>
                              <span>+20% Retention</span>
                          </div>
                      </div>

                      <div className="float-card card-2">
                          <div className="metric-display">
                              <div className="metric-circle">
                                  <span>85%</span>
                              </div>
                              <span>CTR Boost</span>
                          </div>
                      </div>

                      <div className="float-card card-3">
                          <div className="status-indicator">
                              <div className="pulse-dot"></div>
                              <span>Auto-Pilot Active</span>
                          </div>
                      </div>
                  </div>

                  <div className="main-content">
                      <div className="header">
                          <SVGComponent height={50} />
                      </div>

                      <div className="hero">
                          <h1 className="hero-title">
                              Your AI Copilot  for B2C Growth<br/>
                          </h1>

                          <p className="hero-subtitle">
                              Forget workflows and journey builders — PilotX is your AI Copilot that drives <strong>conversions, upsells, and lifelong retention automatically, at scale.</strong>
                          </p>

                        

                          <div className="cta-buttons">
                              <button
                                  className="primary-btn"
                                  onClick={handleBookMeeting}>
                                  Book A Meeting →
                              </button>

                          </div>
                      </div>
                  </div>

                  <div className="visual-section">
                      <div className="dashboard-preview">
                          <div className="dashboard-header">
                              <div className="nav-dots">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                              </div>
                              <div className="dashboard-title">PilotX Dashboard</div>
                          </div>

                          <div className="dashboard-content">
                              <div className="pilot-card">
                                  <div className="pilot-status">
                                      <div className="status-dot active"></div>
                                      <span>Pilot Active</span>
                                  </div>
                                  <h3>Cart Recovery Campaign</h3>
                                  <div className="pilot-metrics">
                                      <div className="metric">
                                          <span className="value">247</span>
                                          <span className="label">Messages Sent</span>
                                      </div>
                                      <div className="metric">
                                          <span className="value">18%</span>
                                          <span className="label">Recovery Rate</span>
                                      </div>
                                  </div>
                              </div>

                              <div className="engagement-graph">
                                  <div className="graph-lines">
                                      <svg viewBox="0 0 200 80" className="engagement-line">
                                          <path d="M10,70 Q50,20 100,30 T190,10" stroke="#FF5555" strokeWidth="2" fill="none" />
                                      </svg>
                                  </div>
                                  <span className="graph-label">Engagement Trend</span>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div className="background-animation">
                      <div className="orbit orbit-1"></div>
                      <div className="orbit orbit-2"></div>
                      <div className="orbit orbit-3"></div>

                      <div className="floating-particles">
                          <div className="particle"></div>
                          <div className="particle"></div>
                          <div className="particle"></div>
                          <div className="particle"></div>
                          <div className="particle"></div>
                      </div>
                  </div>
              </div>} />
              <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
      </Router>
  );
}
